import React from 'react'
import { Result, Skeleton, Button } from 'antd'
import { API, graphqlOperation } from 'aws-amplify'
import * as mutations from '../graphql/mutations'

export default function ConfirmEvent(props) {
    const { talentEventID } = props
    console.log('ConfirmEvent props', props)
    const [result, setResult] = React.useState(null)

    React.useEffect(() => {
        const confirmAttendance = async () => {
            try {
                let resp
                resp = await API.graphql(graphqlOperation(mutations.confirmAttendance, { talentEventID }))
                resp = resp.data.confirmAttendance
                console.log('resp graphql', resp)
                setResult(resp)
            } catch (err) {
                console.error(err)
                setResult('error')
            }

        }
        if (!result) {
            confirmAttendance()
        }
    }, [result])

    if (!result) {
        return (<Skeleton active />)
    } else if (result === 'OK') {
        return (<Result
            status="success"
            title="Děkujeme za potvrzení účasti!"
        />)

    } else if (result === 'NO_EXIST') {
        return (<Result
            status="404"
            title="Událost jsme nemohli najít nebo již proběhla"
        />)
    } else if (result === 'ERROR') {
        return (<Result
            status="500"
            title="Něco se porouchalo, zkus to, prosím, ještě jednou."
        />)

    }

}